import { Typography, Box } from "@material-ui/core";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { Button } from "components";
import { format } from "date-fns";
import { usePopup } from "hooks/usePopup";
import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import purchaseRequestService from "services/purchaseRequestService";
import KeyboardDatePicker from "shared/KeyboardDatePicker";

import { useStyles } from "./styles";

export const DialogUpload = () => {
  const classes = useStyles();
  const { addPopup } = usePopup();
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());

  const onDropAccepted = useCallback(acceptedFiles => {
    setFileName(acceptedFiles[0]?.name);
    setFile(acceptedFiles[0]);
  }, []);

  const handleUpload = async () => {
    try {
      const formattedDate = format(selectedDate, "yyyy-MM-dd");

      setIsLoading(true);

      await purchaseRequestService.importFromExcel(file, formattedDate);

      setIsLoading(false);
      setFile(null);
      setFileName("");

      addPopup({
        type: "success",
        title: "Requisição de compra importada com sucesso!"
      });
    } catch (error) {
      setIsLoading(false);
      const errorMessage =
        error?.response?.data?.msg || error?.response?.data?.message;

      addPopup({
        type: "error",
        title: "O upload falhou",
        description: errorMessage || ""
      });
    }
  };

  const {
    getRootProps,
    getInputProps,
    isDragAccept,
    isDragActive,
    isDragReject
  } = useDropzone({
    onDropAccepted,
    accept: ".xlsx, .xls, .xml, .csv"
  });

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={2}
      width="100%"
    >
      <Box className={classes.dateContainer}>
        <KeyboardDatePicker
          label="Data da Requisição"
          value={selectedDate}
          onChange={date => setSelectedDate(date)}
          format="dd/MM/yyyy"
          variant="inline"
          inputVariant="outlined"
          fullWidth
          views={["date"]}
          disableToolbar
        />
      </Box>

      <div
        {...getRootProps({
          className: `${classes.dropzone}
          ${isDragActive && classes.dragActive}
          ${isDragAccept && classes.dragAccept}
          ${isDragReject && classes.dragReject}`
        })}
      >
        <input {...getInputProps()} disabled={isLoading} />
        {isDragReject ? (
          <Typography>O tipo desse arquivo não é aceito</Typography>
        ) : (
          <Typography component="p">
            {fileName === ""
              ? "Arraste e solte o arquivo aqui ou clique para selecionar o arquivo"
              : fileName}
          </Typography>
        )}
      </div>

      <Box className={classes.actionContainer}>
        <Button
          variant="contained"
          className={classes.btnUpload}
          onClick={handleUpload}
          isLoading={isLoading}
          disabled={!file}
          fullWidth
        >
          Enviar
        </Button>
      </Box>
    </Box>
  );
};
